import React, { memo, useEffect } from "react";
import { useParams } from "react-router-dom";
import { validators } from "investira.sdk";
import { Icon, Stack, Alert, LoadingButton } from "investira.react.components";
import { PageTemplate } from "../../components/templates";
import { useRelatorioContext } from "../../contexts/RelatorioContext";
import { OUTPUT } from "../../enums";
import withOutput from "../../hoc/withOutput";
import services from "../../services";
import ConsultaDuration from "./_components/ConsultaDuration";
import ConsultaEnquadramento from "./_components/ConsultaEnquadramento";
import ConsultaVar from "./_components/ConsultaVar";
import ConsultaSkeleton from "./_components/ConsultaSkeleton";
import ConsultaError from "./_components/ConsultaError";
import ConsultaProcess from "./_components/ConsultaProcess";
import ConsultaStressTest from "./_components/ConsultaStressTest";
import ConsultaConferenciaCustodiante from "./_components/ConsultaConferenciaCustodiante";

const ReportsConsulta = memo((props) => {
  const params = useParams();

  const { actions } = useRelatorioContext();

  const OUTPUTS = {
    duration: ConsultaDuration,
    enquadramento: ConsultaEnquadramento,
    var: ConsultaVar,
    stresstest: ConsultaStressTest,
    conferenciacustodiante: ConsultaConferenciaCustodiante,
  };

  function onDownloadClick(pOutput, pType) {
    const { output_cache_id, files_name, files_created } = pOutput;

    if (output_cache_id && files_created) {
      services.outputs.download(
        {
          output_cache_id,
          type: pType,
        },
        (rRes) => {
          let xOutputFilename = `${files_name}.${pType}`;
          const xFileURL = URL.createObjectURL(rRes.data);
          let xLinkElem = document.createElement("a");
          xLinkElem.href = xFileURL;
          xLinkElem.download = xOutputFilename;
          xLinkElem.click();
        },
        (rErr) => {
          console.log(rErr);
        }
      );
    }
  }

  useEffect(() => {
    actions.handleOutputUpdate(params.output);
  }, [params.output]);

  const ConsultaComponent = OUTPUTS[params.output];

  return (
    <PageTemplate
      title={"Relatório"}
      scrollable={true}
      subtitle={OUTPUT[params.output].descricao}
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          {validators.isEmpty(props.data) ? (
            <></>
          ) : !validators.isEmpty(props.filesErrors) ? (
            <Alert variant="outlined" severity="warning" sx={{ px: 1, py: 0 }}>
              Ocorreu um erro na geração do relátorio.
            </Alert>
          ) : (
            <>
              <LoadingButton
                disabled={
                  !props.isFinished || !validators.isEmpty(props.filesErrors)
                }
                loading={!props.isFinished}
                variant="contained"
                color="primary"
                startIcon={<Icon iconName="download" size={16} />}
                size="small"
                sx={{ px: 2 }}
                onClick={() => onDownloadClick(props.data, "pdf")}
              >
                PDF
              </LoadingButton>
              <LoadingButton
                disabled={
                  !props.isFinished || !validators.isEmpty(props.filesErrors)
                }
                loading={!props.isFinished}
                variant="contained"
                color="primary"
                startIcon={<Icon iconName="download" size={16} />}
                size="small"
                sx={{ px: 2 }}
                onClick={() => onDownloadClick(props.data, "xlsx")}
              >
                XLSX
              </LoadingButton>
            </>
          )}
        </Stack>
      }
    >
      {props.isProcessing && !props.completed ? (
        <ConsultaProcess />
      ) : (validators.isEmpty(props.data) ||
          validators.isEmpty(props.data.response) ||
          validators.isEmpty(props.data.response.detalhe) ||
          validators.isEmpty(props.data.response.resumo)) &&
        !props.isProcessing ? (
        <ConsultaError outputId={params.id} />
      ) : validators.isEmpty(props.data) &&
        props.isProcessing &&
        props.completed ? (
        <ConsultaSkeleton />
      ) : (
        <ConsultaComponent data={props.data} />
      )}
    </PageTemplate>
  );
});

ReportsConsulta.displayName = "ReportsConsulta";

export default withOutput(ReportsConsulta);
